export default __webpack_public_path__ + "static/media/IMG_4546-min.8351fe07.JPG";